import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["projectSpecificationSelect", "classificationSelect"];


  
  static values = { 
    projectId: String 
  }

  updateClassifications() {
    const projectSpecificationId = this.projectSpecificationSelectTarget.value;
    const classificationSelect = this.classificationSelectTarget;
    
    // Clear current classifications
    classificationSelect.innerHTML = '<option value="">Select a classification...</option>';
    
    if (!projectSpecificationId) {
      return;
    }

    // Fetch classifications for the selected project specification
    fetch(`/projects/${this.projectIdValue}/project_specifications/${projectSpecificationId}/classifications/options_for_select.json`)
      .then(response => response.json())
      .then(classifications => {
        classifications.forEach(classification => {
          const option = document.createElement('option');
          option.value = classification.id;
          option.textContent = classification.name;
          classificationSelect.appendChild(option);
        });
      })
      .catch(error => {
        console.error('Error fetching classifications:', error);
      });
  }
}

